import "jquery.cookie";
(function($) {
    // Functions 
    // Action Calls
    $(document).ready(function() {
        var cookieValue = $.cookie("uap_referral");
        if(cookieValue && $(".ets-affiliate_detail").length > 0 ){
            $(".ets-affiliate_detail").val(cookieValue);
        }

        $('.ets_upa-perctange').keypress(function(e) {
            if(isNaN(this.value+""+String.fromCharCode(e.charCode))) return false;
          })
        .on("cut copy paste",function(e){
            e.preventDefault();
        });
    });

    

    
})(jQuery);